import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqSectionComponent } from './faq-section.component';
import { FaqSectionCardComponent } from './faq-section-card/faq-section-card.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';

@NgModule({
  declarations: [FaqSectionComponent, FaqSectionCardComponent],
  imports: [
    CommonModule,
    InlineSVGModule,
    NgbModule,
    NgbAccordionModule,
    PipesModule,
    LoadingModule,
    FGBSharedModule
  ],
  exports: [FaqSectionComponent, FaqSectionCardComponent],
})
export class FaqSectionModule {}
